import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import CustomImage from '../../custom-image';

interface props {
  data: any;
  handleItemSelection: any;
}

interface state {
  list: any;
  listOpen: boolean;
  headerTitle: string;
}

class Dropdown extends Component<props, state> {
  constructor(props) {
    super(props);
    const { data } = this.props;
    this.state = {
      listOpen: false,
      list: data,
      headerTitle: data[0].title,
    };
  }
  handleClickOutside = () => {
    this.setState({
      listOpen: false,
    });
  };
  toggleList = () => {
    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  };
  handleItemSelection = (title, id) => {
    const listData = this.props.data;
    this.setState({ headerTitle: title });
    this.toggleList();
    this.props.handleItemSelection(id);
  };

  render() {
    const { list, listOpen, headerTitle } = this.state;
    return (
      <div className="dd-wrapper">
        <div className="dd-header" onClick={() => this.toggleList()}>
          <div className="dd-header-title">{headerTitle}</div>
          {listOpen ? (
            <div>
              <CustomImage
                className="icon-arrow-up"
                imageName="icon-carrot-down-white.svg"
                alt="Icon Carrot"
                maxWidth="24"
              />
            </div>
          ) : (
            <div>
              <CustomImage
                className="icon-arrow-down"
                imageName="icon-carrot-down-white.svg"
                alt="Icon Carrot"
                maxWidth="24"
              />
            </div>
          )}
        </div>
        {listOpen && (
          <ul className="dd-list">
            {list.map((item, index) =>
              headerTitle !== item.title ? (
                <li
                  className="dd-list-item"
                  key={item.id}
                  onClick={() => this.handleItemSelection(item.title, item.id)}
                >
                  {item.title}
                </li>
              ) : null
            )}
          </ul>
        )}
      </div>
    );
  }
}

export default onClickOutside(Dropdown);
